import React from 'react';
import {Button, Typography} from '@material-ui/core';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import translate from "../../misc/applyTranslation";

const N8nUnavailable = ({classes, error, retry, loading}) => (
  <div className={classes.n8nUnavailable}>
    <CloudOffIcon className={classes.n8nUnavailableIcon}/>
    <Typography variant="h6">  {translate('n8n', 'unavailable_title')}</Typography>
    <Typography className={classes.n8nUnavailableMessage}>
      {translate('n8n', 'cannot_load_text')}
    </Typography>

    <Button
      variant="outlined"
      startIcon={<AutorenewIcon/>}
      onClick={retry}
      disabled={loading}
    >
      {loading ? translate('n8n', 'loading_text') : translate('n8n', 'try_again') }
    </Button>
  </div>
);

export default N8nUnavailable;